import { PRODUCTS, PHONE, PHONE_TEL, WHATSAPP_LINK } from "@/data/site";
import { ProductDialog } from "@/components/ProductDialog";
import { ProductPrice } from "@/components/ProductPrice";

export const ProductGrid = ({ selected, setSelected, tone = "rose" }) => {
  const hoverBtn = tone === "emerald" ? "hover:bg-[#D48C46] hover:text-slate-950" : "hover:bg-rose-600";
  const badge = tone === "emerald" ? "text-emerald-300 bg-emerald-500/10 border-emerald-500/30" : "text-rose-300 bg-rose-500/10 border-rose-500/30";
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {PRODUCTS.map((product, idx) => (
          <div key={product.name} className={`p-5 rounded-2xl border flex flex-col justify-between ${tone === "emerald" ? "bg-[#06140E] border-emerald-900/50" : "bg-slate-950 border-slate-800"}`} data-testid={`product-card-${idx + 1}`}>
            <div>
              <div className={`aspect-square rounded-xl mb-3 overflow-hidden border relative ${tone === "emerald" ? "border-emerald-900/50 bg-[#0B1E16]" : "border-slate-800 bg-slate-900"}`}>
                {product.discount && <span className="absolute top-2 left-2 z-10 text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-md bg-[#D48C46] text-slate-950 shadow" data-testid={`product-card-discount-${idx + 1}`}>{product.discount}</span>}
                <img src={product.img} alt={product.name} loading="lazy" className={`w-full h-full ${product.contain ? "object-contain p-2" : "object-cover"}`} data-testid={`product-image-${idx + 1}`} />
              </div>
              <span className={`inline-block text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-md border ${badge}`}>{product.repair}</span>
              <h3 className="text-base font-bold text-white mt-2">{product.name}</h3>
              {product.brand && <p className="text-[11px] text-slate-500">{product.brand}</p>}
              <p className="text-xs text-slate-400 mt-1">{product.desc}</p>
              <div className="mt-3"><ProductPrice product={product} testId={`product-price-${idx + 1}`} /></div>
            </div>
            <button type="button" onClick={() => setSelected(product)} data-testid={`product-inquire-btn-${idx + 1}`} className={`mt-4 block w-full text-center py-2 text-xs font-bold uppercase tracking-wider rounded-lg text-slate-200 transition-colors ${tone === "emerald" ? "bg-[#0B1E16]" : "bg-slate-900"} ${hoverBtn}`}>
              Inquire
            </button>
          </div>
        ))}
      </div>
      <ProductDialog product={selected} onClose={() => setSelected(null)} phone={PHONE} phoneTel={PHONE_TEL} whatsappLink={WHATSAPP_LINK} />
    </>
  );
};
